import { render, staticRenderFns } from "./XMPoster.vue?vue&type=template&id=f535dc82&scoped=true"
import script from "./XMPoster.vue?vue&type=script&lang=js"
export * from "./XMPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535dc82",
  null
  
)

export default component.exports